<div class="tag" [ngClass]="{ 'pointer interactive': isInteractive() }" (click)="isInteractive() && click.emit()">
    <p class="tag-label label">{{ label() }}</p>
</div>
